/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type TouchpointBatchDTOStatus =
  (typeof TouchpointBatchDTOStatus)[keyof typeof TouchpointBatchDTOStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TouchpointBatchDTOStatus = {
  BUILDING: "BUILDING",
  IN_REVIEW: "IN_REVIEW",
  APPROVED: "APPROVED",
} as const;
